import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import { GetLanguageCode } from "utilities/localize";
import * as utility from "utilities/utils";
import { CONSTANTS } from "utilities/constants";
import { ENDPOINTS } from "utilities/endPoints";

export default function getDeviationDestinations() {

    return async (dispatch) => {

        let productTypes = [ CONSTANTS.PACKAGE, CONSTANTS.HOTEL, CONSTANTS.CRUISE ];
        let responses = [];
        let destinations = [];
        const lang = GetLanguageCode();
        
        try
        {
            // get response for all product types
            await Promise.all(productTypes.map(async (productType) => {
                let url = `${process.env.REACT_APP_SEARCH_API}${ENDPOINTS.SEARCH_API.DESTINATION}?lang=${lang}&type=${productType}&alias=${process.env.REACT_APP_SEARCH_ALIAS}`;
                const response = await client.get(url);
                responses.push(response);
            }));

        }
        catch(error) {
            return dispatch({
                type: actions.GET_DEVIATION_DESTINATION_CITIES_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
        
        // iterate each response and  populate the destination array
        for(const response of responses) {
            if(response.Regions){
                for(const region of response.Regions) {
                    if(region.DestinationGroups) {
                        for(const destinationGroup of region.DestinationGroups) {
                            if(destinationGroup.Destinations) {
                                for(const destination of destinationGroup.Destinations) {
                                    let itemToShow = true;

                                    // to determine if the item to be excluded
                                    if(destination?.AdditionalInformation) {
                                        const itemToHide = destination.AdditionalInformation.find(s => s.code === "IsDisplay" && s.value === "false");
                                        if(itemToHide) {
                                            itemToShow = false;
                                        }
                                    }
                                    if(itemToShow) {
                                        const city = { code: destination.Code, name: destination.Name, providerCode: destination.ProviderCode };
                                        const existCountry = destinations.find(s => s.countryCode?.toLowerCase() === destination.CountryCode?.toLowerCase() && s.countryName?.toLowerCase() === destination.CountryName?.toLowerCase());
                                        if(existCountry) {
                                            const existingCity = (destinations.find(s => s.cities.find(c => c.code?.toLowerCase() === destination.Code?.toLowerCase()) !== undefined));
                                            if(!existingCity) {
                                                existCountry.cities.push(city);
                                            }
                                        }
                                        else {
                                            destinations.push( {
                                                countryCode: destination.CountryCode,
                                                countryName: destination.CountryName,
                                                provinceCode: null,
                                                provinceName: null,
                                                region: region.Name,
                                                regionCode: region.Code,
                                                cities: [city]
                                            }); 
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if(region.SubRegions) {
                            for(const subRegion of region.SubRegions) {
                                const city = { code: subRegion.Code, name: subRegion.Name, providerCode: subRegion.ProviderCode };
                                const existCountry = destinations.find(s => s.countryCode?.toLowerCase() === region.Code?.toLowerCase() && s.countryName?.toLowerCase() === region.Name?.toLowerCase());
                                if(existCountry) {
                                    const existingCity = (destinations.find(s => s.cities.find(c => c.code?.toLowerCase() === subRegion.Code?.toLowerCase()) !== undefined));
                                    if(!existingCity) {
                                        existCountry.cities.push(city);
                                    }
                                }
                                else {
                                    destinations.push( {
                                        countryCode: region.Code,
                                        countryName: region.Name,
                                        provinceCode: null,
                                        provinceName: null,
                                        region: region.Name,
                                        regionCode: region.Code,
                                        cities: [city]
                                    }); 
                                }

                            }
                        }
                    }
                }
            }
        }
        //console.log(destinations);
        return dispatch({
            type: actions.GET_DEVIATION_DESTINATION_CITIES_SUCCESS,
            payload: utility.getResponse(destinations)
        });
    };
}